<app-breadcrumb></app-breadcrumb>

<app-error-state
  [title]="texts.title"
  [description]="subtitle"
  [canRetry]="canRetry"
  [retrying]="isLoading"
  (retry)="tryAgainSubscription()"
  (goHome)="goHome()"
></app-error-state>
